module.exports = __webpack_public_path__ + "img/paylocity.51a54ef5.svg";